import React, { Fragment, useState } from "react";
import styles from "./Measure.module.css";
import Header from "../../Components/Layout/Header";
import {
  Box,
  Button,
  Container,
  Grid,
  InputBase,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
  styled,
  Typography,
} from "@mui/material";
import ruler from "../../Assets/Measing tool.webp";
import artwork1 from "../../Assets/limited edition print-1-min.webp";
import artwork2 from "../../Assets/limited edition print-2-min.webp";
import artwork3 from "../../Assets/limited edition print-3-min.webp";
import artwork4 from "../../Assets/limited edition print-4-min.webp";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import { Link, useNavigate } from "react-router-dom";
import Footer from "../../Components/Layout/Footer";
import { motion } from "motion/react";

const Measure = () => {
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      width: "2rem",
      position: "relative",
      backgroundColor: "transparent",
      border: "none",
      borderLeft: "2px solid #d1d1d1",
      paddingLeft: "0.8rem",
      // padding: "10px 46px 10px 12px",
      // transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 4,
        // borderColor: "#80bdff",
        // boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));
  const [unit, setUnit] = useState("cm");
  const [width, setWidth] = useState(35.5);
  const [height, setHeight] = useState(20);
  const [widthError, setWidthError] = useState("");
  const [heightError, setHeightError] = useState("");

  const navigate = useNavigate();
  const unitChangeHandler = (event: { target: { value: string } }) => {
    setUnit(event.target.value);
  };
  const widthChangeHandler = (event: any) => {
    if (unit === "cm") {
      if (isNaN(event.target.value))
        setWidthError("Make sure you are inputting numbers!");
      else if (event.target.value % 1 !== 0 && event.target.value % 1 !== 0.5)
        setWidthError("Round the values to the nearest 0.5cm");
      else if (event.target.value < 15)
        setWidthError(
          "Think bigger! Your artwork must be at least 15×15cm to be displayed"
        );
      else if (event.target.value > 80)
        setWidthError("Too grand for delivery! Max size allowed is 80×80cm");
      else {
        setWidth(event.target.value);
        setWidthError("");
      }
    } else {
      if (isNaN(event.target.value))
        setWidthError("Make sure you are inputting numbers!");
      else if (event.target.value % 1 !== 0)
        setWidthError("Round the values to the nearest mm");
      else if (event.target.value < 150)
        setWidthError(
          "Think bigger! Your artwork must be at least 150×150mm to be displayed"
        );
      else if (event.target.value > 800)
        setWidthError("Too grand for delivery! Max size allowed is 800×800mm");
      else {
        setWidth(event.target.value / 10);
        setWidthError("");
      }
    }
  };
  const heightChangeHandler = (event: any) => {
    if (unit === "cm") {
      if (isNaN(event.target.value))
        setHeightError("Make sure you are inputting numbers!");
      else if (event.target.value % 1 !== 0 && event.target.value % 1 !== 0.5)
        setHeightError("Round the values to the nearest 0.5cm");
      else if (event.target.value < 15)
        setHeightError(
          "Think bigger! Your artwork must be at least 15×15cm to be displayed"
        );
      else if (event.target.value > 80)
        setHeightError("Too grand for delivery! Max size allowed is 80×80cm");
      else {
        setHeight(event.target.value);
        setHeightError("");
      }
    } else {
      if (isNaN(event.target.value))
        setHeightError("Make sure you are inputting numbers!");
      else if (event.target.value % 1 !== 0)
        setHeightError("Round the values to the nearest mm");
      else if (event.target.value < 150)
        setHeightError(
          "Think bigger! Your artwork must be at least 150×150mm to be displayed"
        );
      else if (event.target.value > 800)
        setHeightError("Too grand for delivery! Max size allowed is 800×800mm");
      else {
        setHeight(event.target.value / 10);
        setHeightError("");
      }
    }
  };
  const startFramingHandler = () => {
    localStorage.setItem("inputWidth", String(width));
    localStorage.setItem("inputHeight", String(height));
    navigate("/online-framing/new");
  };
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: (custom: any) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 * custom },
    }),
  };
  return (
    <Fragment>
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginBottom: 4,
        }}
      >
        <motion.div
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          <Typography
            variant="h3"
            sx={{ my: 4, textAlign: "center" }}
            component="h2"
          >
            It’s time to Measure your artwork
          </Typography>
          <Typography
            sx={{ color: "#949494", textAlign: "center" }}
            variant="h6"
          >
            Please read the section below to learn how to correctly measure your
            artworks, limited edition prints or photos
          </Typography>
          <Typography
            sx={{ color: "#949494", textAlign: "center" }}
            variant="h6"
          ></Typography>
        </motion.div>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 1,
            maxWidth: "40rem",

            // gap: "3rem",
          }}
          spacing={5}
        >
          <Grid item xs={12} sm={6}>
            {" "}
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  px: { xs: 6, sm: 0 },
                }}
              >
                <Typography
                  component="label"
                  htmlFor="width"
                  variant="h5"
                  sx={{ fontWeight: "bolder" }}
                >
                  Width
                </Typography>
                <Box className={styles.input}>
                  <input
                    name="width"
                    defaultValue={width}
                    onChange={widthChangeHandler}
                  />
                  <NativeSelect
                    id="demo-customized-select-native"
                    value={unit}
                    onChange={unitChangeHandler}
                    input={<BootstrapInput />}
                  >
                    <option value="cm">cm</option>
                    <option value="mm">mm</option>
                  </NativeSelect>
                </Box>
              </Box>
            </motion.div>
          </Grid>
          <Grid item xs={12} sm={6}>
            {" "}
            <motion.div
              variants={textVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  px: { xs: 6, sm: 0 },
                }}
              >
                <Typography
                  component="label"
                  htmlFor="height"
                  variant="h5"
                  sx={{ fontWeight: "bolder" }}
                >
                  Height
                </Typography>
                <Box className={styles.input}>
                  <input
                    name="height"
                    defaultValue={height}
                    style={{ color: "#70ad47" }}
                    onChange={heightChangeHandler}
                  />
                  <NativeSelect
                    id="demo-customized-select-native"
                    value={unit}
                    onChange={unitChangeHandler}
                    input={<BootstrapInput />}
                  >
                    <option value={"cm"}>cm</option>
                    <option value={"mm"}>mm</option>
                    {/* <option value={"inch"}>inch</option> */}
                  </NativeSelect>
                </Box>
              </Box>
            </motion.div>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", height: "4rem" }}>
          {widthError ? (
            <Typography
              sx={{ color: "red", marginTop: "1rem", textAlign: "center" }}
            >
              {widthError}
            </Typography>
          ) : (
            heightError && (
              <Typography
                sx={{ color: "red", marginTop: "1rem", textAlign: "center" }}
              >
                {heightError}
              </Typography>
            )
          )}
        </Box>
        <motion.div
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          <button
            className={
              widthError.length > 0 || heightError.length > 0
                ? styles["button-disable"]
                : styles["button"]
            }
            onClick={startFramingHandler}
            disabled={widthError.length > 0 || heightError.length > 0}
          >
            Start Framing
          </button>
        </motion.div>{" "}
        <motion.div
          variants={textVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          <Typography
            variant="h4"
            sx={{
              my: 4,
              mt: 30,
              textAlign: "center",
            }}
            component="h2"
          >
            Measuring Instructions
          </Typography>
          <Typography
            sx={{ color: "#949494", textAlign: "center" }}
            variant="h6"
          >
            Measuring your artwork is very simple. The measurements you take
            will determine how well the frame would fit your artwork, so we must
            get accurate measurements to ensure the best size.
          </Typography>
        </motion.div>
        <Box sx={{ width: "100%" }}>
          {" "}
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography sx={{ fontWeight: "bolder", marginTop: 4 }}>
              STEP 1
            </Typography>
            <Typography sx={{ color: "#7f7f7f", fontWeight: "bolder" }}>
              Ensure your artwork lays flat on a clean flat surface.
            </Typography>
          </motion.div>{" "}
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography sx={{ fontWeight: "bolder", marginTop: 4 }}>
              STEP 2
            </Typography>
            <Typography sx={{ color: "#7f7f7f", fontWeight: "bolder" }}>
              Use a ruler or tape meter for measuring and have a paper to write
              the dimensions before inputting on the website. Check your units
              on the ruler and change the website unit accordingly.
            </Typography>
            <img src={ruler} alt="measing tool" className={styles.ruler} />
          </motion.div>{" "}
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography sx={{ fontWeight: "bolder", marginTop: 4 }}>
              STEP 3
            </Typography>
            <Typography sx={{ color: "#7f7f7f", fontWeight: "bolder" }}>
              Measure the width and height of the area you would like to frame.
              If your artwork has white borders and you don't want to see it,
              use the dimensions of the image you want to be visible. Please
              view the examples below to help you. For print with igh signatures
              please also measure the dimensions of the area you like to be
              visible.
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: 4,
              }}
              container
            >
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={artwork1}
                    alt="measing tool"
                    className={styles.artwork}
                  />
                  <ArrowForwardIosRoundedIcon
                    sx={{ fontSize: "35px", color: "#cdcdcd", mx: 2 }}
                  />
                  <img
                    src={artwork2}
                    alt="measing tool"
                    className={styles.artwork}
                  />
                </Box>
                <Typography sx={{ color: "#7f7f7f", textAlign: "center" }}>
                  Fig 1. Frame the visible area in dotted box by measuring the
                  paper size.
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <img
                    src={artwork3}
                    alt="measing tool"
                    className={styles.artwork}
                  />
                  <ArrowForwardIosRoundedIcon
                    sx={{ fontSize: "35px", color: "#cdcdcd", mx: 2 }}
                  />
                  <img
                    src={artwork4}
                    alt="measing tool"
                    className={styles.artwork}
                  />
                </Box>
                <Typography sx={{ color: "#7f7f7f", textAlign: "center" }}>
                  Fig 2. Frame a portion of your artwork by entering the
                  dimensions of the area you wish to be visible eg the dotted
                  box to include the signature.
                </Typography>
              </Grid>
            </Grid>
          </motion.div>{" "}
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography sx={{ fontWeight: "bolder", marginTop: 4 }}>
              STEP 4
            </Typography>
            <Typography sx={{ color: "#7f7f7f", fontWeight: "bolder" }}>
              Note that the frame will overlap your artwork by 5 mm from each
              side to secure your work in place. If you include a mount (card
              board border), the mount will overlap your artwork by
              approximately 3 mm from each side.
              <br />
              <br />
              <br />
              If you like to include a mount but don't want any overlap, simply
              add 6mm to your width and height dimensions after measuring.
              <br />
              <br />
              Still not sure? Get{" "}
              <Link to={"/contact-us"} style={{ color: "#863a18" }}>
                in touch
              </Link>{" "}
              with us if you need a hand.
            </Typography>
          </motion.div>
        </Box>
      </Container>
    </Fragment>
  );
};

export default Measure;
